<template>
  <div class="navContent">
    <ul
      class="tgList"
      v-if="preventEpidemicList.length>0"
    >
      <li
        v-for="(itm,index) in preventEpidemicList"
        :key="index"
        @click="getZhuantiContent('fangyi',itm.id,itm.html)"
      >
        <div class="tgListLeft">
          <h1>
            <i
              class="tgWuli"
              v-if="itm.html==undefined"
            >课程</i>
            <span v-text="itm.name"></span>
          </h1>
          <h2
            v-if="itm.secondName!=undefined"
            v-html="itm.secondName.length>26?itm.secondName.substring(0,26)+'...':itm.secondName"
          ></h2>
        </div>
        <div class="tgListRight">
          <img :src="contentHost+itm.coverImageSmall" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
import { baseUrl } from '@/assets/js/api'
export default {
    name: 'Special',
    props: {
        preventEpidemicParams: {
            type: Object,
            default () {
                return {
                    gradeId: 2,
                    phaseId: 2,
                    subjectMap: { "1": 2, "2": 2, "3": 32 },
                    version: 2,
                }
            }
        },
        lessonId: {
            type: String,
            default(){
                return ''
            }
        }
    },
    data () {
        return {
            contentHost: '',
            preventEpidemicList: []
        }
    },
    created () {

    },
    mounted () {
        let { gradeId, phaseId, subjectMap } = this.preventEpidemicParams
        this.getPreventEpidemicList(gradeId, phaseId, subjectMap)
    },
    computed: {

    },
    methods: {
        getPreventEpidemicList (gradeId, phaseId, subjectMap) {
            var that = this;
            that.$parent.loading = true;

            var url = baseUrl + '/ures/resource/prelearn/getFangyiList';

            this.$axios.get(url, {
                params: {
                    gradeId,
                    phaseId,
                    subjectMap,
                    version: 2
                }
            }).then(function (res) {
                let { msg, value } = res.data;
                if (res && msg === 'success') {
                    that.contentHost = value.host;
                    that.preventEpidemicList = value.zhuantiList;
                    that.$parent.loading = false;
                    if(that.$parent.isInit) {
                        that.$nextTick(() => {
                            document.documentElement.scrollTop = that.$parent.scrollTop || 0;
                            document.body.scrollTop = that.$parent.scrollTop || 0;
                            that.$parent.isInit = false;
                        })
                    }
                }
            }).catch(function (err) {
                //vant.Toast(that.msg);
            });
        },
        getZhuantiContent (name, id, html) {
            if (html) {
                window.location.href = this.contentHost + html;
            } else {
                this.$router.push({
                    name: 'SpecialContent',
                    query: { params: paramsHelper.encode({ id, name, gradeId: this.preventEpidemicParams.gradeId }),lessonId:this.lessonId }
                })
            }
        }
    }
}
</script>

<style scope lang="less">
.special {
}
</style>
